<template>
  <div class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
      <h1 class="display-1 fw-bold">403</h1>
      <p class="fs-3">У вас нет прав для просмотра.</p>
      <Button label="На главную" @click="$router.push('/')" />
    </div>
  </div>
</template>